/** Todos los temas de ayuda en pantalla, por grupo de módulos (spec 17). */
import type { TemaAyuda } from '../tipos.ts';
import { TEMAS_CAJA_CONTROL } from './caja-control.ts';
import { TEMAS_COMBOS } from './combos.ts';
import { TEMAS_FISCAL } from './fiscal.ts';
import { TEMAS_GENERALES } from './generales.ts';
import { TEMAS_INVENTARIO } from './inventario.ts';
import { TEMAS_VENTAS } from './ventas.ts';

export const TEMAS: TemaAyuda[] = [...TEMAS_GENERALES, ...TEMAS_VENTAS, ...TEMAS_CAJA_CONTROL, ...TEMAS_INVENTARIO, ...TEMAS_COMBOS, ...TEMAS_FISCAL];
